import React from 'react';
import { Card } from "react-bootstrap";
import face_luca_szegletes from "../../assets/img/face_luca_szegletes.png";
import ShowMoreText from "react-show-more-text";
import proj_gnn_see from "../../assets/img/proj_gnn_see.png";

const Luca_Szegletes_gnn_see = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_gnn_see} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_luca_szegletes}
              /* this will be the text on the banner */
              alt="What Can a Neural Network See in a Graph?"
            />{" "}
            <p className="text7">Luca Szegletes</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Department of Automation and Applied Informatics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Here is a theorem that surprises most people the first time they hear it. Take the standard
            neural network architecture used on graphs, each vertex repeatedly updates its own state from
            the states of its neighbours, and ask which pairs of graphs it can tell apart. The answer is
            exactly the pairs separated by the Weisfeiler–Leman colour refinement algorithm, a simple
            combinatorial procedure from 1968. No amount of training, depth, or data changes this. In
            particular, no such network can distinguish two non-isomorphic strongly regular graphs with
            the same parameters.
            <br />
            <br />
            So the expressive power of these models is a question in graph theory, not in engineering.
            Once you know the ceiling, the interesting question is how to raise it: what extra information,
            a few subgraph counts, spectral data from the Laplacian, random node labels, a rewiring of
            the edges, is enough to break past 1-WL, and what does it cost?
            <br />
            <br />
            Possible directions, to be chosen together in the first weeks:
            <br />
            <ul>
              <li>
                Take the constructions that are known to be hard (Cai–Fürer–Immerman graphs,
                strongly regular families, circulants) and study experimentally where the boundary of
                separability actually lies for various architectures, including graph transformers, where
                every vertex may attend to every other and the structure must be re-encoded by hand.
              </li>
              <li>
                Design an augmentation of your own and try to prove or disprove that it strictly
                increases separating power.
              </li>
              <li>
                Study the trade-off: stronger models are typically slower and generalise worse. Is there
                a principled way to describe this trade-off?
              </li>
            </ul>
            The appeal of the topic is that theory and experiment genuinely inform each other here: you
            can construct a counterexample on paper in the morning and watch a model fail on it in the
            afternoon.
            <br />
            <br />
            <b>Prerequisites:</b> Graph theory and linear algebra. Python programming; PyTorch and PyTorch
            Geometric will be used, and the first weeks are set aside for learning them. No machine
            learning course is required. Curiosity and persistence matter more than any of the
            prerequisites listed above, if these questions interest you, we can fill in the technical gaps
            together.
            <br />
            <br />
            Related literature:{" "}
            <br />
            <ul>
                <li>
                <a href="http://arxiv.org/abs/1810.00826">Xu, K., Hu, W., Leskovec, J., & Jegelka, S. (2019). 
                How Powerful are Graph Neural Networks? arXiv [Cs.LG].</a>
                </li>
                <li>
                <a href="http://arxiv.org/abs/2112.09992">Morris, C., Lipman, Y., Maron, H., Rieck, B., Kriege, N. M., Grohe, M., … Borgwardt, K. (2023). 
                Weisfeiler and Leman go Machine Learning: The Story so far. arXiv [Cs.LG].</a>
                </li>
            
            </ul>

            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Luca_Szegletes_gnn_see;